/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/**
 * Defines the Design Language System (DLS) Warning Icon component - an
 * outlined triangle with an exclamation mark, in the theme's warning orange
 * unless given a colour.
 */
export const WarningIcon = ({
  color = dlsColor('orange'),
  ...props
}: IconProps) => {
  const {iconSize, iconColor} = useIconDLS({...props, color});
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M14.4685 14.0782H1.53099C1.14646 14.0782 0.905847 13.6623 1.09756 13.3289L7.56338 2.08653C7.7556 1.75231 8.23779 1.75221 8.43014 2.08636L14.9019 13.3288C15.0938 13.6621 14.8532 14.0782 14.4685 14.0782Z' stroke={iconColor} strokeMiterlimit='10' />
      <path d='M7.99524 5.7605V10.0133' stroke={iconColor} strokeMiterlimit='10' />
      <path d='M7.99524 10.7795V11.9553' stroke={iconColor} strokeMiterlimit='10' />
    </svg>
  );
};

export default WarningIcon;
